import { render, staticRenderFns } from "./PageGuid.vue?vue&type=template&id=fecc5f3a&scoped=true"
import script from "./PageGuid.vue?vue&type=script&lang=js"
export * from "./PageGuid.vue?vue&type=script&lang=js"
import style0 from "./PageGuid.vue?vue&type=style&index=0&id=fecc5f3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecc5f3a",
  null
  
)

export default component.exports